// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"28d18546","488":"cafcf087","817":"baede4c5"}[chunkId] + ".chunk.js";
};